import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.27 13.27"><title>SiteIcons</title><path d="M12.44,5.81h-5v-5A.83.83,0,0,0,5.8.83v5h-5a.83.83,0,1,0,0,1.66h5v5a.83.83,0,0,0,1.66,0v-5h5a.83.83,0,0,0,0-1.66Z"/></svg>
)